import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage} from "react-intl";
import moment from 'moment';
import Duration from "../../../../components/Duration";

class Statistics extends React.Component {
    static propTypes = {
        profile: PropTypes.shape({
            firstContact: PropTypes.arrayOf(
                PropTypes.shape({
                    timeCreated: PropTypes.number.isRequired,
                }).isRequired
            ).isRequired,
            receivedTextCount: PropTypes.number.isRequired,
            receivedVoiceCount: PropTypes.number.isRequired,
            totalVoiceTime: PropTypes.number.isRequired,
            className: PropTypes.string,
        }).isRequired,
    };

    render() {
        const {profile, className} = this.props;

        let classes = "conversation-statistics";
        if (className) {
            classes += " " + className;
        }

        return (
            <div className={classes}>
                <h2 className="mt-3 mb-3">
                    <FormattedMessage id="conversation.statistics" defaultMessage="Statistics for this conversation" />
                </h2>
                <div className="conversation-statistics__content">
                    <div className="conversation-statistics__content--item">
                        <FormattedMessage id="conversation.statistics.first_contact" defaultMessage="First contact"/>
                        <span>: </span>
                        {profile.firstContact[0] &&
                        <FormattedDate value={moment.unix(profile.firstContact[0].timeCreated)}/>
                        }
                        {!profile.firstContact[0] &&
                        <FormattedMessage id="conversation.statistics.first_contact.never" defaultMessage="never"/>
                        }
                    </div>
                    <div className="conversation-statistics__content--item">
                        <FormattedMessage id="conversation.statistics.text_count" defaultMessage="Received texts"/>
                        <span>: </span>
                        <span>{profile.receivedTextCount}</span>
                    </div>
                    <div className="conversation-statistics__content--item">
                        <FormattedMessage id="conversation.statistics.voice_count" defaultMessage="Received calls"/>
                        <span>: </span>
                        <span>{profile.receivedVoiceCount}</span>
                    </div>
                    <div className="conversation-statistics__content--item">
                        <FormattedMessage id="conversation.statistics.voice_time" defaultMessage="Total call time"/>
                        <span>: </span>
                        <Duration long duration={profile.totalVoiceTime}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Statistics;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Statistics/Statistics.jsx